import React from 'react';
import { useSelector } from "react-redux";
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import { CaseForms,UserRoleEnum } from "../../../../helpers/enums";

import './VerificaMetricaCase.scss';

const VerificaMetricaCase = () => {
  const user = useSelector((state) => state.auth);
  const profile = user.impersonationActive ? user.profileImpersonate : user.profile;
  return (
    <div className="VerificaMetricaCase" data-testid="VerificaMetricaCase">
      <CaseGenerator
        type={CaseForms.VerificaMetrica}
        initialValues={
          {...profile,
           ...((profile.role === UserRoleEnum.PRIVATE || profile.businessName==='') && { businessName: `${profile.name} ${profile.surname}` }),
          }
         }
      />
    </div>
  );
};
export default VerificaMetricaCase;
